import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/firstRiders/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/firstRiders/SET_PREV_PAGE_FILTERS";

export const FETCH_CURRENT_USER = "saga/firstRiders/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/firstRiders/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FIRST_TIME_RIDERS_SUCCESS = "saga/firstRiders/FETCH_FIRST_TIME_RIDERS_SUCCESS";

export const UPDATE_ALL_DATA = "saga/firstRiders/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/firstRiders/UPDATE_ALL_DATA_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  try {
    yield getFirstTimeRiders({ short_url, organization_id, date: payload.date });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });
  try {
    yield getFirstTimeRiders({ short_url, organization_id, date: payload.date });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getFirstTimeRiders(params) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/first_time_riders/conversion",
      { params }
    );
    yield put({ type: FETCH_FIRST_TIME_RIDERS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
  }
}
